function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImg14(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "50.11 35.55 679.39 433.37",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-simple--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M693.53,350.43s32.71-144.63-56.41-226.68C558.45,51.32,433.9,23.14,332.37,83c-36.17,21.34-62.5,62.78-104.76,75.58-47.38,14.36-108.3,19.49-152.3,81s-28.2,140.52,30.46,182.58,161.32,1,253.83-2.06S645,528.9,693.53,350.43Z",
    style: {
      fill: "#10A7D0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M693.53,350.43s32.71-144.63-56.41-226.68C558.45,51.32,433.9,23.14,332.37,83c-36.17,21.34-62.5,62.78-104.76,75.58-47.38,14.36-108.3,19.49-152.3,81s-28.2,140.52,30.46,182.58,161.32,1,253.83-2.06S645,528.9,693.53,350.43Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Graphics--inject-2"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M144.25,235.12a13.23,13.23,0,1,0,13.23,13.23A13.24,13.24,0,0,0,144.25,235.12Zm1.35,21.31v1.27h-2.25v-1.27c-2-.4-3-1.92-3-4.29v-1.2H143v1.38c0,1.24.55,1.69,1.42,1.69s1.42-.45,1.42-1.69c0-3.59-5.36-3.77-5.36-8.75,0-2.34,1-3.84,2.89-4.26V238h2.25v1.3c1.94.4,2.94,1.89,2.94,4.26v.55H146v-.73c0-1.24-.5-1.72-1.37-1.72s-1.37.48-1.37,1.72c0,3.59,5.35,3.77,5.35,8.75C148.56,254.51,147.54,256,145.6,256.43Z",
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.25,229.81a18.54,18.54,0,1,0,18.53,18.54A18.54,18.54,0,0,0,144.25,229.81Zm0,33.76a15.23,15.23,0,1,1,15.23-15.22A15.24,15.24,0,0,1,144.25,263.57Z",
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M412,100.48a17.1,17.1,0,1,0,17.09,17.1A17.12,17.12,0,0,0,412,100.48ZM413.77,128v1.64h-2.9V128c-2.54-.52-3.83-2.49-3.83-5.55v-1.55h3.35v1.78c0,1.61.71,2.19,1.84,2.19s1.83-.58,1.83-2.19c0-4.64-6.93-4.87-6.93-11.32,0-3,1.26-5,3.74-5.51v-1.67h2.9v1.67c2.52.52,3.81,2.45,3.81,5.51v.71h-3.36v-.93c0-1.61-.64-2.23-1.77-2.23s-1.77.62-1.77,2.23c0,4.64,6.93,4.87,6.93,11.31C417.61,125.55,416.29,127.52,413.77,128Z",
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412,93.62a24,24,0,1,0,24,24A24,24,0,0,0,412,93.62Zm0,43.65a19.69,19.69,0,1,1,19.68-19.69A19.71,19.71,0,0,1,412,137.27Z",
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M286.4,45.88a24.47,24.47,0,1,0,24.48,24.47A24.49,24.49,0,0,0,286.4,45.88Zm2.49,39.43v2.35h-4.15V85.31c-3.64-.74-5.49-3.55-5.49-7.93V75.16h4.8V77.7c0,2.31,1,3.14,2.63,3.14s2.63-.83,2.63-3.14c0-6.64-9.92-7-9.92-16.19,0-4.34,1.8-7.11,5.35-7.89v-2.4h4.15v2.4c3.6.74,5.44,3.5,5.44,7.89v1h-4.79V61.18c0-2.3-.93-3.18-2.54-3.18s-2.54.88-2.54,3.18c0,6.65,9.92,7,9.92,16.2C294.38,81.76,292.49,84.57,288.89,85.31Z",
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.4,36.05a34.3,34.3,0,1,0,34.31,34.3A34.3,34.3,0,0,0,286.4,36.05Zm0,62.48a28.18,28.18,0,1,1,28.18-28.18A28.21,28.21,0,0,1,286.4,98.53Z",
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("rect", {
    x: 525.18,
    y: 82.43,
    width: 10,
    height: 23,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 538.18,
    y: 68.73,
    width: 10,
    height: 36.7,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 551.18,
    y: 73.6,
    width: 10,
    height: 31.83,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 564.18,
    y: 65.68,
    width: 10,
    height: 39.75,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "542.9 59.23 554.54 70.86 569.71 59.57 572.15 55.32 574.74 56.82 574.73 48.84 567.83 52.84 570.42 54.33 568.18 58.21 554.73 68.23 542.61 56.11 528.23 77.2 529.88 78.33 542.9 59.23",
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("rect", {
    x: 110.08,
    y: 97.82,
    width: 8.49,
    height: 19.52,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 121.12,
    y: 86.19,
    width: 8.49,
    height: 31.16,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 132.15,
    y: 90.32,
    width: 8.49,
    height: 27.02,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 143.19,
    y: 83.6,
    width: 8.49,
    height: 33.74,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "125.13 78.13 135 88 147.88 78.41 149.95 74.81 152.15 76.08 152.14 69.31 146.28 72.7 148.48 73.96 146.58 77.26 135.16 85.76 124.88 75.48 112.67 93.38 114.07 94.34 125.13 78.13",
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("rect", {
    x: 636.74,
    y: 245.44,
    width: 15.27,
    height: 35.11,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 656.58,
    y: 224.53,
    width: 15.27,
    height: 56.03,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 676.43,
    y: 231.96,
    width: 15.27,
    height: 48.59,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 696.27,
    y: 219.88,
    width: 15.27,
    height: 60.67,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "663.79 210.03 681.55 227.78 704.71 210.54 708.43 204.06 712.39 206.34 712.37 194.17 701.84 200.27 705.79 202.54 702.38 208.47 681.84 223.76 663.35 205.26 641.39 237.46 643.91 239.18 663.79 210.03",
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plants--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M703,354.66s3-2.31,3.22-2.48c2-2,4.74-7,3.33-9.8a3.74,3.74,0,0,0-5.41-1.32c-1.88,1.19-2.68,3.82-2.86,5.92C701.09,349.45,703,354.65,703,354.66Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M728.39,348.84c-2.28-2.19-7.87-1.06-10.35.29-.21.11-3.36,2.31-3.32,2.35l.06,0c-.88.17-1.83.36-2.86.6-1.89.44-4,1-6.32,1.69a68.43,68.43,0,0,0-7.27,2.68,50,50,0,0,0-7.62,4.13s-.05.05-.08.06c.57-.72,2.12-2.79,2.22-3,1.42-2.44,2.73-8,.62-10.33a3.74,3.74,0,0,0-5.56.15c-1.5,1.65-1.58,4.4-1.19,6.47.44,2.34,3.4,6.55,3.63,6.89a66.37,66.37,0,0,0-6.88,5.53c-1.27,1.15-2.52,2.36-3.75,3.58.48-.64.91-1.22,1-1.31,1.42-2.43,2.73-8,.62-10.33a3.75,3.75,0,0,0-5.57.15c-1.5,1.65-1.58,4.4-1.19,6.47s2.85,5.75,3.51,6.71l-1.41,1.41c-2.23,2.28-4.45,4.57-6.7,6.74-.79.77-1.6,1.5-2.4,2.23.42-.57.78-1.06.82-1.14,1.42-2.43,2.73-8,.62-10.33a3.74,3.74,0,0,0-5.56.15c-1.5,1.65-1.58,4.4-1.19,6.47s2.61,5.39,3.39,6.53c-.85.72-1.7,1.45-2.55,2.11-.59.44-1.13.9-1.75,1.31l-1.8,1.24c-1.18.74-2.38,1.52-3.54,2.21L653.62,392c.79-.76,2.32-2.27,2.44-2.41a14.53,14.53,0,0,0,2.76-6.78,4.43,4.43,0,0,0,.47-.69,3.74,3.74,0,0,0-1.69-5.3c-2.91-1.22-7.72,1.84-9.55,4-.11.12-1.13,1.63-1.76,2.59.28-.62.57-1.22.85-1.86.57-1.27,1.1-2.55,1.68-3.92l.77-2c.28-.68.48-1.43.72-2.15.53-1.67,1-3.4,1.41-5.15,1.11.5,5.07,2.21,7.19,2.21s4.79-.57,6.14-2.35a3.74,3.74,0,0,0-.86-5.5c-2.7-1.65-7.91.65-10.05,2.5-.14.11-1.52,1.6-2.27,2.44.25-1.05.5-2.1.71-3.17.61-3.1,1.14-6.26,1.67-9.4l.51-2.88c.4.18,5.06,2.31,7.44,2.32,2.1,0,4.79-.58,6.14-2.36a3.73,3.73,0,0,0-.87-5.49c-2.69-1.65-7.91.65-10,2.49-.17.14-2.16,2.29-2.64,2.87.38-2.12.78-4.22,1.25-6.28a67.66,67.66,0,0,1,2.42-8.19c.18.09,5,2.33,7.48,2.34,2.1,0,4.79-.58,6.14-2.35a3.74,3.74,0,0,0-.87-5.5c-2.69-1.65-7.91.65-10,2.49-.17.15-2.31,2.46-2.67,2.91.06-.15.1-.32.16-.47a48.3,48.3,0,0,1,3.86-7.64c.82-1.35,1.68-2.6,2.54-3.79.86.51,4.83,2.8,7,3.05s4.83-.05,6.36-1.66a3.74,3.74,0,0,0-.25-5.56c-2.5-1.94-7.94-.22-10.26,1.37-.13.09-1.32,1.11-2.18,1.87.4-.53.8-1.09,1.19-1.59,1.46-1.89,2.92-3.53,4.22-5,.74-.82,1.43-1.54,2.09-2.21,1.11.06,5.58.25,7.59-.53s4.26-2.26,4.88-4.41a3.73,3.73,0,0,0-2.79-4.81c-3.1-.57-7.14,3.46-8.47,5.95-.11.21-1.53,3.78-1.47,3.79h.07c-.64.63-1.32,1.31-2,2.08-1.34,1.41-2.83,3-4.34,4.89a67.57,67.57,0,0,0-4.58,6.25,48.59,48.59,0,0,0-4.08,7.65.3.3,0,0,1,0,.1c.09-.92.23-3.51.22-3.71-.16-2.81-2.13-8.16-5.18-9a3.75,3.75,0,0,0-4.56,3.2c-.34,2.2,1.11,4.54,2.57,6.05,1.66,1.71,6.46,3.59,6.84,3.74a65.54,65.54,0,0,0-2.69,8.41c-.43,1.67-.8,3.36-1.15,5.06,0-.8.08-1.52.07-1.62-.16-2.82-2.12-8.17-5.18-9a3.74,3.74,0,0,0-4.56,3.2c-.34,2.2,1.11,4.54,2.58,6.05s5.54,3.22,6.62,3.65l-.39,2c-.6,3.14-1.2,6.27-1.87,9.32-.24,1.08-.51,2.13-.78,3.18,0-.71.07-1.3.06-1.4-.16-2.81-2.12-8.16-5.18-9a3.75,3.75,0,0,0-4.56,3.2c-.34,2.2,1.11,4.54,2.58,6.05s5.15,3.06,6.43,3.58c-.31,1.07-.62,2.14-1,3.16-.26.7-.45,1.38-.74,2.06s-.55,1.36-.82,2c-.57,1.26-1.15,2.58-1.73,3.8-.4.85-.8,1.66-1.2,2.47.25-1.07.7-3.17.71-3.35.27-2.81-.86-8.4-3.76-9.65a3.75,3.75,0,0,0-5,2.47c-.67,2.13.41,4.66,1.63,6.38,1.34,1.89,5.61,4.4,6.15,4.71-.67,1.34-1.32,2.64-2,3.85q-1.26,2.4-2.4,4.44c.34.5.77,1.12,1.27,1.83.87-1.62,1.81-3.43,2.79-5.42.68-1.36,1.38-2.82,2.08-4.34a40,40,0,0,0,4.66,1c.22,2.37,2.25,6.53,2.52,7.06-1.3.76-2.56,1.48-3.77,2.14-2.07,1.14-4,2.15-5.71,3l1.25,1.61c1.64-.88,3.44-1.88,5.38-3,1.32-.76,2.71-1.6,4.13-2.48.4.46,3.65,4.22,5.76,5.19,1.91.89,4.59,1.49,6.56.44a3.73,3.73,0,0,0,1.52-5.35c-1.76-2.63-7.46-2.72-10.17-2-.16.05-1.84.74-2.9,1.19.58-.36,1.15-.7,1.74-1.08,1.17-.74,2.32-1.51,3.56-2.34l1.78-1.28c.6-.41,1.18-.92,1.78-1.39,1.36-1.1,2.69-2.29,4-3.52.65,1,3,4.64,4.78,5.81s4.31,2.16,6.42,1.43a3.75,3.75,0,0,0,2.31-5.07c-1.34-2.86-7-3.81-9.76-3.46-.17,0-2.15.51-3.23.79.78-.74,1.57-1.48,2.34-2.26,2.22-2.24,4.39-4.58,6.58-6.91.66-.71,1.34-1.42,2-2.12.23.37,2.95,4.72,4.92,6,1.76,1.17,4.32,2.17,6.42,1.43a3.74,3.74,0,0,0,2.31-5.06c-1.34-2.87-7-3.82-9.75-3.47-.21,0-3.06.73-3.78.94,1.48-1.55,3-3.09,4.5-4.54a65.27,65.27,0,0,1,6.54-5.5c.11.17,2.92,4.73,4.94,6.07,1.76,1.17,4.32,2.17,6.43,1.43A3.74,3.74,0,0,0,704.3,364c-1.34-2.87-7-3.82-9.76-3.47-.22,0-3.28.78-3.83,1l.4-.31a48.35,48.35,0,0,1,7.44-4.24c1.42-.67,2.83-1.24,4.2-1.76.44.9,2.48,5,4.17,6.42s4.05,2.62,6.23,2.12A3.74,3.74,0,0,0,716,359c-1-3-6.5-4.56-9.32-4.51-.15,0-1.71.2-2.84.36.63-.22,1.27-.47,1.87-.67,2.26-.77,4.38-1.34,6.26-1.82,1.07-.27,2-.49,3-.69.89.66,4.52,3.28,6.62,3.75s4.81.46,6.51-1A3.74,3.74,0,0,0,728.39,348.84Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M659.31,319.46c1.19,2.16,5.66,5.45,5.67,5.45s1.27-3.6,1.32-3.84c.59-2.76.1-8.44-2.63-10a3.74,3.74,0,0,0-5.24,1.88C657.52,315,658.3,317.61,659.31,319.46Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.86,111.13c.09,0-2.33-6-2.53-6.36-2.28-4.16-9.12-10.88-14.35-9.88a6.29,6.29,0,0,0-4.62,8.14c1.08,3.6,5,6.11,8.28,7.35C168.54,111.84,177.85,111.13,177.86,111.13Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.08,67.37c-4.58,2.69-5.31,12.25-4.28,16.88.09.4,2.2,6.51,2.28,6.45l.09-.07c-.12,1.51-.24,3.13-.34,4.9-.14,3.27-.28,7-.16,11a110.13,110.13,0,0,0,1,13,82,82,0,0,0,3.18,14.24.76.76,0,0,1,.06.16c-.9-1.27-3.55-4.73-3.79-5-3.29-3.42-11.67-8.08-16.45-5.75a6.3,6.3,0,0,0-2.3,9.08c2,3.19,6.39,4.58,9.93,4.9,4,.36,12.17-2.5,12.82-2.73a111.23,111.23,0,0,0,5.79,13.69c1.29,2.59,2.67,5.15,4.08,7.71-.82-1.07-1.56-2-1.68-2.15-3.29-3.41-11.67-8.08-16.44-5.74a6.29,6.29,0,0,0-2.31,9.07c2,3.19,6.4,4.58,9.93,4.9s10.61-2,12.46-2.6c.56,1,1.1,2,1.65,2.92,2.67,4.67,5.35,9.31,7.84,13.95.88,1.63,1.69,3.27,2.5,4.91-.73-.95-1.35-1.74-1.46-1.85-3.29-3.42-11.67-8.09-16.45-5.75a6.3,6.3,0,0,0-2.3,9.08c2,3.18,6.39,4.58,9.92,4.9s9.93-1.75,12.14-2.5c.78,1.71,1.56,3.41,2.24,5.1.44,1.16.94,2.25,1.32,3.44s.78,2.33,1.17,3.48c.67,2.24,1.37,4.54,2,6.74.42,1.53.8,3,1.18,4.47-.85-1.64-2.59-4.81-2.77-5.05a24.41,24.41,0,0,0-9.71-7.6,7.64,7.64,0,0,0-.9-1.06,6.3,6.3,0,0,0-9.36.29c-3.31,4.16-.56,13.35,2.07,17.3.16.23,2.12,2.58,3.39,4l-2.62-2.23c-1.79-1.5-3.62-2.95-5.58-4.51-1-.73-2-1.46-3-2.19s-2.09-1.43-3.14-2.15c-2.47-1.63-5.05-3.15-7.69-4.64,1.31-1.56,5.9-7.2,6.88-10.62s1.26-8-1-11a6.29,6.29,0,0,0-9.29-1.12c-3.91,3.61-2.57,13.11-.57,17.41.12.27,1.9,3.2,2.91,4.79-1.59-.88-3.17-1.76-4.81-2.6-4.73-2.41-9.6-4.71-14.44-7-1.49-.71-3-1.43-4.43-2.15.47-.55,6.06-7.13,7.16-11,1-3.41,1.27-8-1-11a6.3,6.3,0,0,0-9.3-1.13c-3.9,3.61-2.57,13.11-.57,17.42.15.32,2.72,4.53,3.43,5.57-3.25-1.58-6.47-3.19-9.58-4.9a110.89,110.89,0,0,1-12.15-7.67c.22-.26,6.09-7.1,7.21-11,1-3.41,1.26-8-1-11a6.3,6.3,0,0,0-9.3-1.13c-3.9,3.61-2.57,13.11-.57,17.41.16.34,2.92,4.87,3.48,5.65-.22-.16-.47-.31-.69-.47A81.16,81.16,0,0,1,118.23,165c-1.81-1.94-3.44-3.9-5-5.84,1.22-1.16,6.75-6.54,8.15-10s2.14-7.84.23-11.07a6.3,6.3,0,0,0-9.12-2.14c-4.27,3.16-4,12.75-2.48,17.25.08.24,1.2,2.64,2,4.37-.68-.88-1.4-1.79-2-2.65-2.39-3.23-4.38-6.34-6.12-9.11-1-1.58-1.83-3-2.61-4.39.61-1.77,3-8.92,2.63-12.54S102.23,121,99,119A6.3,6.3,0,0,0,90,121.33c-2.34,4.77,2.33,13.15,5.75,16.45.3.28,5.43,4.2,5.46,4.11l0-.1c.72,1.32,1.52,2.74,2.42,4.27,1.68,2.81,3.61,6,5.94,9.27a111.18,111.18,0,0,0,8,10.28,82.44,82.44,0,0,0,10.51,10.12l.15.1c-1.46-.56-5.58-2-5.91-2.05-4.63-1-14.19-.3-16.89,4.28a6.3,6.3,0,0,0,3.09,8.84c3.41,1.57,7.86.29,11-1.39,3.52-1.89,8.77-8.79,9.19-9.34a111.31,111.31,0,0,0,12.39,8.21c2.5,1.45,5.06,2.83,7.65,4.18-1.28-.44-2.42-.82-2.58-.86-4.64-1-14.2-.31-16.89,4.28a6.29,6.29,0,0,0,3.08,8.84c3.42,1.57,7.86.29,11-1.39s7.76-7.5,8.95-9.05c1,.51,2,1,3,1.53,4.8,2.42,9.6,4.82,14.24,7.31,1.63.88,3.21,1.8,4.79,2.72-1.13-.39-2.09-.71-2.24-.74-4.63-1-14.2-.31-16.89,4.28a6.29,6.29,0,0,0,3.09,8.84c3.41,1.56,7.86.29,11-1.39s7.31-6.94,8.74-8.77c1.59,1,3.19,2,4.68,3,1,.73,2,1.36,3,2.14l2.9,2.26c1.79,1.5,3.65,3,5.36,4.54,1.2,1,2.32,2,3.45,3.07-1.61-.89-4.82-2.58-5.1-2.69-4.42-1.72-14-2.45-17.34,1.68a6.28,6.28,0,0,0,1.71,9.2c3.14,2.07,7.72,1.48,11.07.3,3.67-1.31,9.69-7.08,10.44-7.8,1.87,1.69,3.67,3.35,5.35,4.94,2.2,2.09,4.23,4.07,6.08,5.92,1-.32,2.17-.73,3.55-1.22-2.23-2.15-4.72-4.5-7.49-7-1.89-1.72-4-3.52-6.08-5.35a67.26,67.26,0,0,0,3.81-7.08c3.94.74,11.59-.64,12.58-.83.63,2.44,1.22,4.82,1.73,7.08.91,3.88,1.66,7.45,2.29,10.63,1-.4,2.09-.83,3.18-1.28-.68-3-1.47-6.43-2.4-10.1-.63-2.48-1.35-5.12-2.12-7.82.93-.43,8.49-4,11-6.93,2.32-2.69,4.52-6.76,3.72-10.43a6.29,6.29,0,0,0-8-4.91c-5.06,1.64-7.82,10.82-7.81,15.57,0,.28.35,3.32.6,5.23-.32-1.1-.62-2.17-1-3.3-.66-2.24-1.38-4.46-2.16-6.85l-1.25-3.45c-.39-1.16-.95-2.34-1.43-3.52-1.17-2.72-2.48-5.42-3.86-8.11,2-.59,8.89-2.76,11.6-5.08s5.48-6,5.25-9.74a6.28,6.28,0,0,0-7.13-6.06c-5.25.85-9.38,9.51-10.09,14.21,0,.29-.17,3.71-.2,5.6-.85-1.61-1.68-3.23-2.59-4.83-2.61-4.62-5.4-9.22-8.17-13.82-.85-1.41-1.67-2.82-2.51-4.24.7-.19,9-2.6,12-5.19,2.69-2.31,5.48-6,5.25-9.74a6.29,6.29,0,0,0-7.13-6.07c-5.25.86-9.38,9.51-10.08,14.21-.06.35-.24,5.28-.22,6.54-1.83-3.11-3.63-6.23-5.28-9.38a108.46,108.46,0,0,1-5.91-13.1c.33-.09,9-2.56,12.1-5.22,2.69-2.3,5.48-6,5.25-9.74a6.29,6.29,0,0,0-7.13-6.07c-5.25.86-9.37,9.52-10.08,14.21-.06.37-.25,5.68-.21,6.64-.1-.26-.23-.52-.32-.78a82,82,0,0,1-3.45-14c-.44-2.62-.71-5.15-.92-7.62,1.66-.29,9.24-1.72,12.3-3.8s6.11-5.36,6.29-9.11a6.29,6.29,0,0,0-6.42-6.81c-5.31.27-10.37,8.42-11.58,13-.07.25-.46,2.86-.72,4.77-.08-1.11-.18-2.26-.23-3.33-.21-4-.16-7.71-.08-11,.06-1.85.15-3.53.24-5.1,1.48-1.14,7.39-5.81,9.11-9s3-7.57,1.39-11A6.29,6.29,0,0,0,180.08,67.37Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.82,165.72c4.05-.93,11.43-6.66,11.43-6.67s-5.25-3.71-5.61-3.9c-4.2-2.22-13.61-4-17.42-.33a6.28,6.28,0,0,0,.64,9.34C92.74,166.57,97.36,166.52,100.82,165.72Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Device--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M206,128.71H638.91a12.74,12.74,0,0,1,12.74,12.74V426.22a0,0,0,0,1,0,0H193.28a0,0,0,0,1,0,0V141.44A12.74,12.74,0,0,1,206,128.71Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 266.01,
    y: 411.9,
    width: 315.01,
    height: 15.52,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 266.01,
    y: 419.37,
    width: 315.01,
    height: 8.05,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.21,436.62s5.18,6.32,20.7,11.5H670.12s11.5-2.88,16.67-10.93Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 155.16,
    y: 425.29,
    width: 532.74,
    height: 12.09,
    rx: 3.86,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.39,137.7a4,4,0,1,0-4,4A4,4,0,0,0,426.39,137.7Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.6,212.43h0a1.15,1.15,0,0,1-1.15-1.15V177.94a1.16,1.16,0,0,1,1.15-1.15h0a1.15,1.15,0,0,1,1.15,1.15v33.34A1.14,1.14,0,0,1,197.6,212.43Z",
    style: {
      fill: "#263238",
      stroke: "#fff",
      strokeLinejoin: "round",
      strokeWidth: "0.691688px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 211.88,
    y: 151.95,
    width: 421.17,
    height: 238.01,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 281.87,
    y: 151.95,
    width: 351.18,
    height: 14.08,
    style: {
      fill: "#10A7D0",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M103.58,351.9l-3.86,24-2.58,53.64s5.58,9.44,6.44,10.73,7.72,4.72,6.87,6.43-12.88,0-12.88,0a19,19,0,0,0-5.15-6c-3.43-2.58-4.29-1.08-4.29-3.65s.43-6.87.43-6.87-3.43-51.7-3.43-59-.86-16.73-.86-16.73Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.41,353.47l-1,24-4.28,51.06,3.29,12.51s2,4,2.64,4.94-.33,2-1.65,2H82.58a4.87,4.87,0,0,1-4.12-2.25,28.5,28.5,0,0,0-3.24-4.34c-2-2-1-7.57-1-9.22V428.9s-4.94-38.21-4.61-43.81.66-9.88.66-9.88l-2-21.74Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.35,320.63l.12-.46-.37-2.59,2.57-9.87,1.21.27,1.45-5.21,22.43-.13a79.41,79.41,0,0,0,10.24,0,55.69,55.69,0,0,1,5.82-.42l.15.58,1.18-.67s2.58,17.59,1.72,31.75-3,35.65-3,35.65H66.68l-.84-19.15-.16,0c-.12-1.26-.26-2.53-.39-3.78L63,330.84C62.18,325.93,61.35,320.63,61.35,320.63Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.06,242.25s8.6,43.19,7.07,45.49-4.86,4.09-6.9,1.79-3.84-36.29-4.6-38.85S102.58,240.46,106.06,242.25Z",
    style: {
      fill: "#10A7D0",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.08,274.71s6.39,3.06,6.9,4.6-.76,7.41-3.06,9.45-5.88,4.09-7.16.77S107.25,274.19,111.08,274.71Z",
    style: {
      fill: "#10A7D0",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.39,278.52s-1,1.81-1,6.15,1,4.86,1.54,4.09,1.5-5.53,1.5-5.53S116.94,278.24,114.39,278.52Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.39,278.52s7.92.5,9.27,1.18a45,45,0,0,1,8.09,5.89c2.19,2.19,2,3.54.84,3.54h-3.71c-1.68,0-6.06-2.19-6.57-2.36s-2-.84-3.37-1.35a6.76,6.76,0,0,1-2.52-2.19l-2.7-1.51S113.55,279.53,114.39,278.52Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.8,283.91a17.93,17.93,0,0,0,3.36,3.37c2,1.51,1.69,2.19.51,2s-4-2.7-4-2.7-3.2-.67-4.21-1.68a7.26,7.26,0,0,1-1.52-2.53l.17-1",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.88,289.13s-3.87-4.38-5.39-5.9",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.74,288.79s-2.7-4.71-5.4-6.57",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.59,289.13a46.1,46.1,0,0,0-4.21-6.23",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.32,235s14.74,6.28,14.74,7.25,2.22,23.15,2.22,26.61,1,28.24.83,31.56,1.71,19,1.29,19.23-.29,2.88-3.47,2.32-2.67-18.92-2.67-18.92l-2.49-15.78L101.63,277s0-10.93-1.1-17a80.74,80.74,0,0,0-4.71-14.82C95.54,244.77,91.32,235,91.32,235Z",
    style: {
      fill: "#10A7D0",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.93,231.75s-7.4,2.76-11.58,4.59c-6,2.61-10.34,3.78-10.62,5.58s5.65,48.67,5.65,48.67l-8.21,32.19s13.14,5,22.41,4.6a59.59,59.59,0,0,0,14.5-2.12l.45-21.79s1.73-13.1-1.79-32.71c-3-16.53-8.32-37.9-8.32-37.9Z",
    style: {
      fill: "#10A7D0",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.5,237.57a42,42,0,0,1,5.67,7.48,43,43,0,0,1,2.91,6.64l-2.08.83,4.57,5.68a35.32,35.32,0,0,1-.28,10.1c-1,5.13-2.07,13.43-2.07,13.43s-8.86.14-11.49-1.52-11.91-19.94-12.32-21.46S81.14,251,81.14,251l-2.85-.67-5.45-1.27s1.8-11.77,2.9-14.81.56-3.46,3.05-4.43,12.74,7.33,12.74,7.33Z",
    style: {
      fill: "#10A7D0",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.33,219.43a38.77,38.77,0,0,1-2.08,8.31,38.13,38.13,0,0,1-1.66,3.6,278.75,278.75,0,0,1,7.06,28.38c2.49,13.71,4.15,27.13,4.15,33.92s-.27,9.83-.27,9.83,1.52.83,5.53.55a27.22,27.22,0,0,0,7.2-1.52s-3.46-29.91-3.6-37.1S93.33,239,93.33,239l1.24-4s-4.15-5-5.12-8.72S86.27,219.16,84.33,219.43Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.47,226.29c1,3.73,5.1,8.65,5.1,8.65l-1.24,4,.49,1.36c-4.52-4.42-7.3-12.28-7.3-12.28Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.65,250.18a36.15,36.15,0,0,0,11.65.41C99,256,100.6,262,100.66,265.4c.14,7.19,3.6,37.1,3.6,37.1a27.22,27.22,0,0,1-7.2,1.52c-4,.28-5.53-.55-5.53-.55s.27-3.05.27-9.83-1.66-20.21-4.15-33.92C87.07,256.53,86.38,253.28,85.65,250.18Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 93.94,
    y1: 272.84,
    x2: 93.06,
    y2: 273.86,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 99.7,
    y1: 266.18,
    x2: 94.61,
    y2: 272.06,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 97.42,
    y1: 271.99,
    x2: 93.48,
    y2: 275.72,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.29,214.11a2.87,2.87,0,0,0,3.39-1.55c1.06-2.24-1.11-2.6-1-4.74s2.29-4,1.13-6-9-6.95-12.82-9.15-9.34-1-13.91.44-8.08,3-9.26,6.32-1.1,6.27-2.48,8.78-4,2.8-2.58,5.72,4,2.65,3.35,4.73-1.67,4.32-.12,5.45,4.21-.45,5.5.59,2.2,1.78,3.26,1.66,1.74-2.43,4.25-5.54,5.29-5.78,8.75-6.62,6.62-2.25,8.68-1.77A13,13,0,0,1,109.29,214.11Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81,214.45a2.8,2.8,0,0,1-2.66.25",
    style: {
      fill: "none",
      stroke: "gray",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.73,203.17s0,3.55-5.57,3.55-12.29-.38-15,1.9c-1.54,1.32-3.29,3.6-5,5",
    style: {
      fill: "none",
      stroke: "gray",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.31,201.7a7.73,7.73,0,0,0-5.61,2.1c-3.55,3.43-5.83,7.48-8.49,7.61a8.36,8.36,0,0,1-3.67-.38",
    style: {
      fill: "none",
      stroke: "gray",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.19,202.16a9.07,9.07,0,0,0-1.38-.33",
    style: {
      fill: "none",
      stroke: "gray",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.61,207.7s1.17,5.31-1.12,9.34-2.57,3.59-3.22,7.45-2.21,5.8-5.35,8.5-5,2.79-6.92,1.69-8.25-6.32-8.58-8.3-.82-4.29-.82-4.29a10.68,10.68,0,0,1-1.73-1.82,7,7,0,0,1-.26-1.28s2.17,1.43,3.81.19.93-3.42,3.75-4.67,6.64-.95,7.82-2.14,0-1.9,3.07-2.22S108.81,210.73,110.61,207.7Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.6,218.87s-1.78,1-1.86,2.45,1.41,4.34.64,4.9-2.82.19-2.82.19",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.88,228.85A2.36,2.36,0,0,1,97,227.5",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.27,215.93s-1.11-1.54-4.16-1.33",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106,217.54s1.22-.72,1.89,1.1",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.21,219.21c-.3.68-.31,1.34,0,1.47s.78-.31,1.09-1,.3-1.34,0-1.47S98.51,218.52,98.21,219.21Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.27,221.05c-.3.68-.31,1.34,0,1.47s.78-.31,1.09-1,.3-1.34,0-1.47S105.57,220.36,105.27,221.05Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.22,279.52s4.69-.33,5.52,0,9.79,3.55,10.9,4.66a43.87,43.87,0,0,1,4.66,6.24c1.41,2.49.66,2.49.25,2.49a3,3,0,0,1-1.81-1.58,31,31,0,0,0-3-3.46l-1.92-.89s1.92,3.51,3,5.17,1.71,2.62,1.09,2.93c-1,.49-2.17-1.2-2.58-1.75s-1.55-1.72-1.55-1.72,1.24,2.49,1.1,2.91-1.13.64-1.94-.56c-.34-.51-4-4.94-4-4.94a35.55,35.55,0,0,1,1.82,4.39c0,.55-.55.69-1.66,0s-2.59-4.13-3.14-4.82a3.56,3.56,0,0,0-2-.87,9.46,9.46,0,0,1-2.77-1.1C93.61,286,92.5,285,92.5,285l-3,1.25.22-6.08Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 101.89,
    y1: 288.97,
    x2: 100.57,
    y2: 286.49,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 106.76,
    y1: 291.56,
    x2: 103.02,
    y2: 285.75,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 106.85,
    y1: 287,
    x2: 105.6,
    y2: 284.93,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.68,254.87l-1,24.51,25.06-.56-.14,10.53s-17.85,2.9-26.72,2.63-14.12.55-14.81-.56,4.52-44.52,4.52-44.52.83-6.92,2.21-7.33,10-3.11,10-3.11",
    style: {
      fill: "#10A7D0",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 59.24,
    y1: 279.62,
    x2: 58.02,
    y2: 279.66,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 67.71,
    y1: 279.38,
    x2: 60.84,
    y2: 279.57,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.13,437.08c0-1.59.17-3.84.29-5.33,3.54,3.46,10.76,10.35,12.45,10.74a9.65,9.65,0,0,0,4.77-.53c2.26,1.55,5.4,3.58,4.81,4.77-.86,1.72-12.88,0-12.88,0a19,19,0,0,0-5.15-6,11,11,0,0,0-2.74-1.56l2.74,1.56-2.15,6.1H88.19v-8.51l.16.09A2.6,2.6,0,0,1,88.13,437.08Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.68,435c0-1.33.44-1,.51-1.95,1.93,2.83,6.15,9.21,7.4,9.63,1.56.52,4.34-.18,4.34-.18l.28.13c.63,1.22,1.47,2.82,1.86,3.4.65,1-.33,2-1.65,2H82.58a4.87,4.87,0,0,1-4.12-2.25c-.21-.33-.44-.69-.68-1l-.71,2.47h-3.3V436.24Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 110.05,
    y: 294.75,
    width: 49.11,
    height: 2.36,
    transform: "translate(269.2 591.85) rotate(180)",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 125.16,
    y: 266.89,
    width: 49.11,
    height: 30.22,
    transform: "translate(299.42 563.99) rotate(180)",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Charts--inject-2"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 229.21,
    y1: 299.21,
    x2: 520.81,
    y2: 299.21,
    style: {
      fill: "none",
      stroke: "#ccc",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 229.21,
    y1: 293.2,
    x2: 520.81,
    y2: 293.2,
    style: {
      fill: "none",
      stroke: "#ccc",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 229.21,
    y1: 287.18,
    x2: 520.81,
    y2: 287.18,
    style: {
      fill: "none",
      stroke: "#ccc",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 229.21,
    y1: 281.16,
    x2: 520.81,
    y2: 281.16,
    style: {
      fill: "none",
      stroke: "#ccc",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 229.21,
    y1: 275.14,
    x2: 520.81,
    y2: 275.14,
    style: {
      fill: "none",
      stroke: "#ccc",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 229.21,
    y1: 269.12,
    x2: 520.81,
    y2: 269.12,
    style: {
      fill: "none",
      stroke: "#ccc",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 229.21,
    y1: 263.1,
    x2: 520.81,
    y2: 263.1,
    style: {
      fill: "none",
      stroke: "#ccc",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 229.21,
    y1: 257.08,
    x2: 520.81,
    y2: 257.08,
    style: {
      fill: "none",
      stroke: "#ccc",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 229.21,
    y1: 251.06,
    x2: 520.81,
    y2: 251.06,
    style: {
      fill: "none",
      stroke: "#ccc",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 229.21,
    y1: 245.04,
    x2: 520.81,
    y2: 245.04,
    style: {
      fill: "none",
      stroke: "#ccc",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 229.21,
    y1: 239.02,
    x2: 520.81,
    y2: 239.02,
    style: {
      fill: "none",
      stroke: "#ccc",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 229.21,
    y1: 233,
    x2: 520.81,
    y2: 233,
    style: {
      fill: "none",
      stroke: "#ccc",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 229.21,
    y1: 226.98,
    x2: 520.81,
    y2: 226.98,
    style: {
      fill: "none",
      stroke: "#ccc",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 229.21,
    y1: 220.96,
    x2: 520.81,
    y2: 220.96,
    style: {
      fill: "none",
      stroke: "#ccc",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 229.21,
    y1: 214.94,
    x2: 520.81,
    y2: 214.94,
    style: {
      fill: "none",
      stroke: "#ccc",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 229.21,
    y1: 208.93,
    x2: 520.81,
    y2: 208.93,
    style: {
      fill: "none",
      stroke: "#ccc",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 239.24,
    y: 202.24,
    width: 11.37,
    height: 96.31,
    style: {
      fill: "#10A7D0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 254.29,
    y: 254.4,
    width: 11.37,
    height: 44.14,
    style: {
      fill: "#10A7D0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 269.34,
    y: 262.43,
    width: 11.37,
    height: 36.12,
    style: {
      fill: "#10A7D0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 284.39,
    y: 216.28,
    width: 11.37,
    height: 82.26,
    style: {
      fill: "#10A7D0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 299.44,
    y: 257.08,
    width: 11.37,
    height: 41.47,
    style: {
      fill: "#10A7D0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 314.49,
    y: 238.35,
    width: 11.37,
    height: 60.19,
    style: {
      fill: "#10A7D0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 329.53,
    y: 214.94,
    width: 11.37,
    height: 83.6,
    style: {
      fill: "#10A7D0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 344.58,
    y: 189.53,
    width: 11.37,
    height: 109.02,
    style: {
      fill: "#10A7D0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 359.63,
    y: 241.7,
    width: 11.37,
    height: 56.85,
    style: {
      fill: "#10A7D0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 374.68,
    y: 265.77,
    width: 11.37,
    height: 32.77,
    style: {
      fill: "#10A7D0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 389.73,
    y: 279.15,
    width: 11.37,
    height: 19.4,
    style: {
      fill: "#10A7D0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 404.77,
    y: 263.77,
    width: 11.37,
    height: 34.78,
    style: {
      fill: "#10A7D0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 419.82,
    y: 230.33,
    width: 11.37,
    height: 68.22,
    style: {
      fill: "#10A7D0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 434.87,
    y: 286.51,
    width: 11.37,
    height: 12.04,
    style: {
      fill: "#10A7D0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 449.92,
    y: 262.43,
    width: 11.37,
    height: 36.12,
    style: {
      fill: "#10A7D0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 464.97,
    y: 278.48,
    width: 11.37,
    height: 20.06,
    style: {
      fill: "#10A7D0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 480.02,
    y: 190.2,
    width: 11.37,
    height: 108.35,
    style: {
      fill: "#10A7D0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 495.06,
    y: 208.93,
    width: 11.37,
    height: 89.62,
    style: {
      fill: "#10A7D0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.63,176.42v-.93h1.62v.93c1.4.29,2.12,1.37,2.12,3.07v.4H235.5v-.52c0-.9-.36-1.24-1-1.24s-1,.34-1,1.24c0,2.58,3.85,2.71,3.85,6.3,0,1.7-.73,2.8-2.13,3.08v.92h-1.62v-.92c-1.41-.28-2.13-1.38-2.13-3.08v-.87h1.86v1c0,.9.4,1.22,1,1.22s1-.32,1-1.22c0-2.58-3.86-2.71-3.86-6.3C231.55,177.81,232.25,176.73,233.63,176.42Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.6,178c-.63,0-1,.34-1,1.24v1.34h-1.87v-1.22c0-2,1-3.15,2.94-3.15s2.95,1.14,2.95,3.15c0,3.95-3.93,5.42-3.93,7.49a2.44,2.44,0,0,0,0,.27h3.74v1.79h-5.71v-1.54c0-3.7,3.91-4.31,3.91-7.93C242.62,178.25,242.23,178,241.6,178Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.65,179.31c0-2,1.06-3.15,3-3.15s3,1.14,3,3.15v6.54c0,2-1.06,3.15-3,3.15s-3-1.15-3-3.15Zm2,6.66c0,.9.39,1.24,1,1.24s1-.34,1-1.24v-6.78c0-.9-.39-1.24-1-1.24s-1,.34-1,1.24Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.82,187v1.9h-1.9V187Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.06,179.39c0-1.14-.4-1.44-1-1.44s-1,.34-1,1.24V180h-1.86v-.69c0-2,1-3.15,2.94-3.15s2.94,1.14,2.94,3.15v.33c0,1.34-.43,2.19-1.38,2.58a2.55,2.55,0,0,1,1.38,2.64v1c0,2-1,3.15-2.94,3.15s-2.94-1.15-2.94-3.15v-1H258V186c0,.9.4,1.24,1,1.24s1-.31,1-1.42v-1c0-1.16-.4-1.59-1.29-1.59h-.67v-1.8h.77c.74,0,1.19-.32,1.19-1.32Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.23,179.42c0-2.12,1-3.26,3-3.26s2.94,1.14,2.94,3.15v.33h-1.87v-.45c0-.9-.39-1.24-1-1.24s-1.1.34-1.1,1.54v2.3a1.89,1.89,0,0,1,1.84-1.11c1.45,0,2.18,1,2.18,2.87v2.3c0,2-1.05,3.15-3,3.15s-3-1.15-3-3.15Zm2,4.29V186c0,.9.4,1.22,1,1.22s1-.32,1-1.22v-2.26c0-.9-.39-1.24-1-1.24S265.2,182.81,265.2,183.71Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.29,189a2.82,2.82,0,0,1-3.08-3.15v-1a2.76,2.76,0,0,1,1.22-2.62,2.6,2.6,0,0,1-1.22-2.53v-.4a3.09,3.09,0,1,1,6.17,0v.4a2.63,2.63,0,0,1-1.22,2.53,2.76,2.76,0,0,1,1.22,2.62v1A2.83,2.83,0,0,1,273.29,189Zm-1.11-8.91c0,1,.47,1.32,1.11,1.32s1.12-.32,1.12-1.32v-.7c0-1.14-.49-1.44-1.12-1.44s-1.11.3-1.11,1.44Zm1.11,7.12c.63,0,1.1-.31,1.12-1.42v-1.17c0-1-.42-1.41-1.12-1.41s-1.11.43-1.11,1.41v1.17C272.18,186.9,272.67,187.21,273.29,187.21Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.56,188.86V187h1.91v1.7l-.87,2h-.8l.52-1.79Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.79,178c-.63,0-1,.34-1,1.24v1.34H280.9v-1.22c0-2,1-3.15,2.94-3.15s3,1.14,3,3.15c0,3.95-3.93,5.42-3.93,7.49a2.44,2.44,0,0,0,0,.27h3.74v1.79H280.9v-1.54c0-3.7,3.91-4.31,3.91-7.93C284.81,178.25,284.42,178,283.79,178Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.81,179.39c0-1.14-.4-1.44-1-1.44s-1,.34-1,1.24V180H287.9v-.69c0-2,1-3.15,2.94-3.15s2.94,1.14,2.94,3.15v.33c0,1.34-.43,2.19-1.38,2.58a2.55,2.55,0,0,1,1.38,2.64v1c0,2-1,3.15-2.94,3.15s-2.94-1.15-2.94-3.15v-1h1.86V186c0,.9.4,1.24,1,1.24s1-.31,1-1.42v-1c0-1.16-.4-1.59-1.29-1.59h-.67v-1.8h.77c.74,0,1.19-.32,1.19-1.32Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 527.39,
    y: 177.92,
    width: 93.13,
    height: 121,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 543.51,
    y1: 185.35,
    x2: 555.84,
    y2: 185.35,
    style: {
      fill: "none",
      stroke: "#757575",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 562.78,
    y1: 185.35,
    x2: 575.11,
    y2: 185.35,
    style: {
      fill: "none",
      stroke: "#757575",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 582.05,
    y1: 185.35,
    x2: 594.38,
    y2: 185.35,
    style: {
      fill: "none",
      stroke: "#757575",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 601.31,
    y1: 185.35,
    x2: 613.64,
    y2: 185.35,
    style: {
      fill: "none",
      stroke: "#757575",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 559.36,
    y1: 179.73,
    x2: 559.36,
    y2: 297.25,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 540.07,
    y1: 179.73,
    x2: 540.07,
    y2: 297.25,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 578.96,
    y1: 179.73,
    x2: 578.96,
    y2: 297.25,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 598.56,
    y1: 179.73,
    x2: 598.56,
    y2: 297.25,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "534.41 182.96 532.15 186.89 536.68 186.89 534.41 182.96",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 543.51,
    y1: 194.46,
    x2: 555.84,
    y2: 194.46,
    style: {
      fill: "none",
      stroke: "#757575",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 562.78,
    y1: 194.46,
    x2: 575.11,
    y2: 194.46,
    style: {
      fill: "none",
      stroke: "#757575",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 582.05,
    y1: 194.46,
    x2: 594.38,
    y2: 194.46,
    style: {
      fill: "none",
      stroke: "#757575",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 601.31,
    y1: 194.46,
    x2: 613.64,
    y2: 194.46,
    style: {
      fill: "none",
      stroke: "#757575",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "534.41 196 536.68 192.07 532.15 192.07 534.41 196",
    style: {
      fill: "#10A7D0"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 543.51,
    y1: 203.56,
    x2: 555.84,
    y2: 203.56,
    style: {
      fill: "none",
      stroke: "#757575",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 562.78,
    y1: 203.56,
    x2: 575.11,
    y2: 203.56,
    style: {
      fill: "none",
      stroke: "#757575",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 582.05,
    y1: 203.56,
    x2: 594.38,
    y2: 203.56,
    style: {
      fill: "none",
      stroke: "#757575",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 601.31,
    y1: 203.56,
    x2: 613.64,
    y2: 203.56,
    style: {
      fill: "none",
      stroke: "#757575",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "534.41 201.18 532.15 205.11 536.68 205.11 534.41 201.18",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 543.51,
    y1: 212.67,
    x2: 555.84,
    y2: 212.67,
    style: {
      fill: "none",
      stroke: "#757575",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 562.78,
    y1: 212.67,
    x2: 575.11,
    y2: 212.67,
    style: {
      fill: "none",
      stroke: "#757575",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 582.05,
    y1: 212.67,
    x2: 594.38,
    y2: 212.67,
    style: {
      fill: "none",
      stroke: "#757575",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 601.31,
    y1: 212.67,
    x2: 613.64,
    y2: 212.67,
    style: {
      fill: "none",
      stroke: "#757575",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "534.41 214.21 536.68 210.29 532.15 210.29 534.41 214.21",
    style: {
      fill: "#10A7D0"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 543.51,
    y1: 221.78,
    x2: 555.84,
    y2: 221.78,
    style: {
      fill: "none",
      stroke: "#757575",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 562.78,
    y1: 221.78,
    x2: 575.11,
    y2: 221.78,
    style: {
      fill: "none",
      stroke: "#757575",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 582.05,
    y1: 221.78,
    x2: 594.38,
    y2: 221.78,
    style: {
      fill: "none",
      stroke: "#757575",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 601.31,
    y1: 221.78,
    x2: 613.64,
    y2: 221.78,
    style: {
      fill: "none",
      stroke: "#757575",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "534.41 223.32 536.68 219.4 532.15 219.4 534.41 223.32",
    style: {
      fill: "#10A7D0"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 543.51,
    y1: 230.89,
    x2: 555.84,
    y2: 230.89,
    style: {
      fill: "none",
      stroke: "#757575",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 562.78,
    y1: 230.89,
    x2: 575.11,
    y2: 230.89,
    style: {
      fill: "none",
      stroke: "#757575",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 582.05,
    y1: 230.89,
    x2: 594.38,
    y2: 230.89,
    style: {
      fill: "none",
      stroke: "#757575",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 601.31,
    y1: 230.89,
    x2: 613.64,
    y2: 230.89,
    style: {
      fill: "none",
      stroke: "#757575",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "534.41 232.43 536.68 228.51 532.15 228.51 534.41 232.43",
    style: {
      fill: "#10A7D0"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 543.51,
    y1: 240,
    x2: 555.84,
    y2: 240,
    style: {
      fill: "none",
      stroke: "#757575",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 562.78,
    y1: 240,
    x2: 575.11,
    y2: 240,
    style: {
      fill: "none",
      stroke: "#757575",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 582.05,
    y1: 240,
    x2: 594.38,
    y2: 240,
    style: {
      fill: "none",
      stroke: "#757575",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 601.31,
    y1: 240,
    x2: 613.64,
    y2: 240,
    style: {
      fill: "none",
      stroke: "#757575",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "534.41 237.61 532.15 241.54 536.68 241.54 534.41 237.61",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 543.51,
    y1: 249.11,
    x2: 555.84,
    y2: 249.11,
    style: {
      fill: "none",
      stroke: "#757575",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 562.78,
    y1: 249.11,
    x2: 575.11,
    y2: 249.11,
    style: {
      fill: "none",
      stroke: "#757575",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 582.05,
    y1: 249.11,
    x2: 594.38,
    y2: 249.11,
    style: {
      fill: "none",
      stroke: "#757575",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 601.31,
    y1: 249.11,
    x2: 613.64,
    y2: 249.11,
    style: {
      fill: "none",
      stroke: "#757575",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "534.41 246.72 532.15 250.65 536.68 250.65 534.41 246.72",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 543.51,
    y1: 258.22,
    x2: 555.84,
    y2: 258.22,
    style: {
      fill: "none",
      stroke: "#757575",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 562.78,
    y1: 258.22,
    x2: 575.11,
    y2: 258.22,
    style: {
      fill: "none",
      stroke: "#757575",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 582.05,
    y1: 258.22,
    x2: 594.38,
    y2: 258.22,
    style: {
      fill: "none",
      stroke: "#757575",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 601.31,
    y1: 258.22,
    x2: 613.64,
    y2: 258.22,
    style: {
      fill: "none",
      stroke: "#757575",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "534.41 259.76 536.68 255.83 532.15 255.83 534.41 259.76",
    style: {
      fill: "#10A7D0"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 543.51,
    y1: 267.32,
    x2: 555.84,
    y2: 267.32,
    style: {
      fill: "none",
      stroke: "#757575",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 562.78,
    y1: 267.32,
    x2: 575.11,
    y2: 267.32,
    style: {
      fill: "none",
      stroke: "#757575",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 582.05,
    y1: 267.32,
    x2: 594.38,
    y2: 267.32,
    style: {
      fill: "none",
      stroke: "#757575",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 601.31,
    y1: 267.32,
    x2: 613.64,
    y2: 267.32,
    style: {
      fill: "none",
      stroke: "#757575",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "534.41 264.94 532.15 268.87 536.68 268.87 534.41 264.94",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 543.51,
    y1: 276.43,
    x2: 555.84,
    y2: 276.43,
    style: {
      fill: "none",
      stroke: "#757575",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 562.78,
    y1: 276.43,
    x2: 575.11,
    y2: 276.43,
    style: {
      fill: "none",
      stroke: "#757575",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 582.05,
    y1: 276.43,
    x2: 594.38,
    y2: 276.43,
    style: {
      fill: "none",
      stroke: "#757575",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 601.31,
    y1: 276.43,
    x2: 613.64,
    y2: 276.43,
    style: {
      fill: "none",
      stroke: "#757575",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "534.41 277.97 536.68 274.05 532.15 274.05 534.41 277.97",
    style: {
      fill: "#10A7D0"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 530.9,
    y1: 189.56,
    x2: 618.11,
    y2: 189.56,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 530.9,
    y1: 198.67,
    x2: 618.11,
    y2: 198.67,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 530.9,
    y1: 207.78,
    x2: 618.11,
    y2: 207.78,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 530.9,
    y1: 216.89,
    x2: 618.11,
    y2: 216.89,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 530.9,
    y1: 226,
    x2: 618.11,
    y2: 226,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 530.9,
    y1: 235.11,
    x2: 618.11,
    y2: 235.11,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 530.9,
    y1: 244.21,
    x2: 618.11,
    y2: 244.21,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 530.9,
    y1: 253.32,
    x2: 618.11,
    y2: 253.32,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 530.9,
    y1: 262.43,
    x2: 618.11,
    y2: 262.43,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 530.9,
    y1: 271.54,
    x2: 618.11,
    y2: 271.54,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 530.9,
    y1: 280.65,
    x2: 618.11,
    y2: 280.65,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 530.9,
    y1: 289.76,
    x2: 618.11,
    y2: 289.76,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 543.51,
    y1: 285.54,
    x2: 555.84,
    y2: 285.54,
    style: {
      fill: "none",
      stroke: "#757575",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 562.78,
    y1: 285.54,
    x2: 575.11,
    y2: 285.54,
    style: {
      fill: "none",
      stroke: "#757575",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 582.05,
    y1: 285.54,
    x2: 594.38,
    y2: 285.54,
    style: {
      fill: "none",
      stroke: "#757575",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 601.31,
    y1: 285.54,
    x2: 613.64,
    y2: 285.54,
    style: {
      fill: "none",
      stroke: "#757575",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "534.41 283.16 532.15 287.08 536.68 287.08 534.41 283.16",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 543.51,
    y1: 294.65,
    x2: 555.84,
    y2: 294.65,
    style: {
      fill: "none",
      stroke: "#757575",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 562.78,
    y1: 294.65,
    x2: 575.11,
    y2: 294.65,
    style: {
      fill: "none",
      stroke: "#757575",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 582.05,
    y1: 294.65,
    x2: 594.38,
    y2: 294.65,
    style: {
      fill: "none",
      stroke: "#757575",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 601.31,
    y1: 294.65,
    x2: 613.64,
    y2: 294.65,
    style: {
      fill: "none",
      stroke: "#757575",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "534.41 296.19 536.68 292.26 532.15 292.26 534.41 296.19",
    style: {
      fill: "#10A7D0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M511.72,333.67c0-1.55.71-2.39,2.21-2.39s2.15.84,2.15,2.31v.24h-1.37v-.33c0-.66-.28-.91-.74-.91s-.8.25-.8,1.13v1.68a1.36,1.36,0,0,1,1.33-.81c1.07,0,1.61.75,1.61,2.1v1.68a2.2,2.2,0,1,1-4.39,0Zm1.45,3.14v1.65c0,.66.28.9.74.9s.75-.24.75-.9v-1.65c0-.66-.29-.91-.75-.91S513.17,336.15,513.17,336.81Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M516.9,333.59a2.2,2.2,0,1,1,4.39,0v4.78a2.2,2.2,0,1,1-4.39,0Zm1.44,4.87c0,.66.29.91.75.91s.75-.25.75-.91v-5c0-.66-.29-.91-.75-.91s-.75.25-.75.91Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M522.14,332.79a1.4,1.4,0,1,1,2.79,0v3a1.4,1.4,0,1,1-2.79,0Zm.92,3.09c0,.4.17.57.47.57s.48-.17.48-.57v-3.16c0-.41-.19-.58-.48-.58s-.47.17-.47.58Zm4.1-4.5H528l-3.62,9.2h-.86Zm-.46,4.77a1.4,1.4,0,1,1,2.79,0v3a1.4,1.4,0,1,1-2.79,0Zm.92,3.09c0,.41.17.58.47.58s.48-.17.48-.58v-3.16c0-.4-.19-.57-.48-.57s-.47.17-.47.57Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M514.6,348.09c0-.83-.29-1-.75-1s-.75.24-.75.9v.59h-1.37V348a2,2,0,0,1,2.16-2.31c1.42,0,2.15.84,2.15,2.31v.24a1.79,1.79,0,0,1-1,1.89,1.88,1.88,0,0,1,1,1.93v.73c0,1.47-.73,2.31-2.15,2.31a2,2,0,0,1-2.16-2.31v-.77h1.37v.86c0,.65.29.9.75.9s.75-.22.75-1v-.73c0-.85-.29-1.17-1-1.17h-.48v-1.31h.56c.54,0,.87-.24.87-1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M516.9,348a2.2,2.2,0,1,1,4.39,0v4.79a2.2,2.2,0,1,1-4.39,0Zm1.44,4.88c0,.65.29.9.75.9s.75-.25.75-.9v-5c0-.66-.29-.9-.75-.9s-.75.24-.75.9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M522.14,347.23a1.4,1.4,0,1,1,2.79,0v3a1.4,1.4,0,1,1-2.79,0Zm.92,3.09c0,.41.17.58.47.58s.48-.17.48-.58v-3.15c0-.41-.19-.58-.48-.58s-.47.17-.47.58Zm4.1-4.49H528L524.39,355h-.86Zm-.46,4.76a1.4,1.4,0,1,1,2.79,0v3a1.4,1.4,0,1,1-2.79,0Zm.92,3.09c0,.41.17.58.47.58s.48-.17.48-.58v-3.15c0-.41-.19-.58-.48-.58s-.47.17-.47.58Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M513.93,361.48c-.46,0-.75.25-.75.91v1h-1.37v-.89a2,2,0,0,1,2.16-2.31c1.41,0,2.15.84,2.15,2.31,0,2.89-2.88,4-2.88,5.48a.62.62,0,0,0,0,.19H516v1.32h-4.18v-1.13c0-2.71,2.87-3.16,2.87-5.81C514.68,361.7,514.39,361.48,513.93,361.48Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M516.9,362.48a2.2,2.2,0,1,1,4.39,0v4.78a2.2,2.2,0,1,1-4.39,0Zm1.44,4.87c0,.66.29.91.75.91s.75-.25.75-.91v-5c0-.66-.29-.91-.75-.91s-.75.25-.75.91Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M522.14,361.68a1.4,1.4,0,1,1,2.79,0v3a1.4,1.4,0,1,1-2.79,0Zm.92,3.08c0,.41.17.58.47.58s.48-.17.48-.58v-3.15c0-.41-.19-.58-.48-.58s-.47.17-.47.58Zm4.1-4.49H528l-3.62,9.2h-.86ZM526.7,365a1.4,1.4,0,1,1,2.79,0v3a1.4,1.4,0,1,1-2.79,0Zm.92,3.09c0,.41.17.58.47.58s.48-.17.48-.58V365c0-.4-.19-.57-.48-.57s-.47.17-.47.57Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450.37,370.91a22.52,22.52,0,1,1,26.36-36.43",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinejoin: "round",
      strokeWidth: 6
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480.48,365.62a22.54,22.54,0,0,1-30.11,5.29",
    style: {
      fill: "none",
      stroke: "#757575",
      strokeLinejoin: "round",
      strokeWidth: 6
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M476.73,334.48a22.52,22.52,0,0,1,3.75,31.14",
    style: {
      fill: "none",
      stroke: "#10A7D0",
      strokeLinejoin: "round",
      strokeWidth: 6
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 501.65,
    cy: 336.56,
    r: 3.82,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 501.65,
    cy: 350.58,
    r: 3.82,
    style: {
      fill: "#c4f0d1"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 501.65,
    cy: 364.6,
    r: 3.82,
    style: {
      fill: "#757575"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 443,
    y: 312.14,
    width: 88.43,
    height: 3.03,
    style: {
      fill: "#ccc"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 242.39,
    y1: 322.17,
    x2: 418.64,
    y2: 322.17,
    style: {
      fill: "none",
      stroke: "#ccc",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 242.39,
    y1: 330.42,
    x2: 418.64,
    y2: 330.42,
    style: {
      fill: "none",
      stroke: "#ccc",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 242.39,
    y1: 338.67,
    x2: 418.64,
    y2: 338.67,
    style: {
      fill: "none",
      stroke: "#ccc",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 242.39,
    y1: 346.92,
    x2: 418.64,
    y2: 346.92,
    style: {
      fill: "none",
      stroke: "#ccc",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 242.39,
    y1: 355.17,
    x2: 418.64,
    y2: 355.17,
    style: {
      fill: "none",
      stroke: "#ccc",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 242.39,
    y1: 363.42,
    x2: 418.64,
    y2: 363.42,
    style: {
      fill: "none",
      stroke: "#ccc",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 242.39,
    y1: 371.67,
    x2: 418.64,
    y2: 371.67,
    style: {
      fill: "none",
      stroke: "#ccc",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 242.39,
    y1: 379.92,
    x2: 418.64,
    y2: 379.92,
    style: {
      fill: "none",
      stroke: "#ccc",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 229.9,
    y1: 322.17,
    x2: 238.39,
    y2: 322.17,
    style: {
      fill: "none",
      stroke: "#ccc",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 229.9,
    y1: 330.42,
    x2: 238.39,
    y2: 330.42,
    style: {
      fill: "none",
      stroke: "#ccc",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 229.9,
    y1: 338.67,
    x2: 238.39,
    y2: 338.67,
    style: {
      fill: "none",
      stroke: "#ccc",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 229.9,
    y1: 346.92,
    x2: 238.39,
    y2: 346.92,
    style: {
      fill: "none",
      stroke: "#ccc",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 229.9,
    y1: 355.17,
    x2: 238.39,
    y2: 355.17,
    style: {
      fill: "none",
      stroke: "#ccc",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 229.9,
    y1: 363.42,
    x2: 238.39,
    y2: 363.42,
    style: {
      fill: "none",
      stroke: "#ccc",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 229.9,
    y1: 371.67,
    x2: 238.39,
    y2: 371.67,
    style: {
      fill: "none",
      stroke: "#ccc",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 229.9,
    y1: 379.92,
    x2: 238.39,
    y2: 379.92,
    style: {
      fill: "none",
      stroke: "#ccc",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "245.52 341.16 247.62 339.29 248.79 342.1 251.59 340.23 252.53 342.57 255.1 335.79 256.27 337.89 256.97 342.33 259.54 343.27 260.71 347.24 262.35 348.88 263.75 345.6 267.02 352.38 268.42 351.91 271.46 369.21 272.63 366.64 274.73 371.78 278 351.68 280.81 356.35 283.15 351.91 284.78 355.65 286.88 353.78 288.52 357.76 292.26 353.78 293.9 358.93 297.63 360.8 299.5 356.35 301.38 356.12 303.01 353.32 304.65 353.32 305.81 360.09 307.69 353.08 310.02 352.62 312.36 350.98 314.46 352.38 316.1 358.69 317.73 357.52 320.54 362.2 322.17 359.39 323.58 362.2 324.75 361.26 326.62 361.73 330.12 357.06 332.46 359.63 334.09 354.95 335.96 356.35 337.83 345.14 339.24 346.77 342.27 336.26 343.44 336.26 344.14 331.11 346.48 330.88 347.41 325.74 349.75 332.05 351.15 329.25 352.79 339.76 354.89 340.46 356.06 336.96 360.04 334.15 362.14 339.29 362.37 348.41 365.18 349.81 367.75 345.14 369.85 345.84 372.42 345.6 374.06 348.88 375.93 344.44 377.33 344.44 381.77 354.49 382.94 350.98 384.81 351.21 387.14 356.82 389.71 352.85 391.58 333.92 394.15 336.96 395.09 322 397.43 324.8 398.6 332.75 401.4 331.58 403.5 338.13 405.14 338.83 406.07 350.98 407.48 348.18 408.18 344.9 411.92 345.84 413.55 344.9 416.59 349.11",
    style: {
      fill: "none",
      stroke: "#10A7D0",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 230.84,
    y: 307.59,
    width: 21,
    height: 10.64,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.84,307.59v2.53a2.53,2.53,0,0,1-2.53-2.53Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.33,318.23c0-.11,0-.22,0-.34a2.53,2.53,0,0,1,2.53-2.53",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.84,310.12h.07a2.53,2.53,0,0,0,2.53-2.53",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.44,317.89c0,.12,0,.23,0,.34h-2.58v-2.87h.07A2.53,2.53,0,0,1,233.44,317.89Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.62,312.91a3.28,3.28,0,1,0-3.28,3.28A3.28,3.28,0,0,0,244.62,312.91Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.07,310.87v-.31h.54v.31c.46.09.7.45.7,1V312h-.62v-.18c0-.29-.12-.41-.33-.41s-.32.12-.32.41c0,.86,1.27.9,1.27,2.09a.92.92,0,0,1-.7,1v.3h-.54V315a.92.92,0,0,1-.71-1v-.28H241V314c0,.29.13.4.34.4s.34-.11.34-.4c0-.86-1.28-.9-1.28-2.09A.91.91,0,0,1,241.07,310.87Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 258.27,
    y: 312.14,
    width: 88.43,
    height: 3.03,
    style: {
      fill: "#ccc"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 549.23,
    y: 321.39,
    width: 69.25,
    height: 6.6,
    style: {
      fill: "#ccc"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 549.23,
    y: 321.39,
    width: 22.09,
    height: 6.6,
    style: {
      fill: "#10A7D0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 549.23,
    y: 338.45,
    width: 69.25,
    height: 6.6,
    style: {
      fill: "#ccc"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 549.23,
    y: 338.45,
    width: 46.31,
    height: 6.6,
    style: {
      fill: "#10A7D0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 549.23,
    y: 355.51,
    width: 69.25,
    height: 6.6,
    style: {
      fill: "#ccc"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 549.23,
    y: 355.51,
    width: 9.77,
    height: 6.6,
    style: {
      fill: "#10A7D0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 549.23,
    y: 372.56,
    width: 69.25,
    height: 6.6,
    style: {
      fill: "#ccc"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 549.23,
    y: 372.56,
    width: 60.75,
    height: 6.6,
    style: {
      fill: "#10A7D0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 548.99,
    y: 312.14,
    width: 69.04,
    height: 3.03,
    style: {
      fill: "#ccc"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Coins--inject-2"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 218.85,
    cy: 396.76,
    r: 50.67,
    transform: "translate(-216.45 270.96) rotate(-45)",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 244.01,
    y1: 354.52,
    x2: 246.15,
    y2: 354.52,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 248.82,
    y1: 358.25,
    x2: 251.75,
    y2: 358.25,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 254.16,
    y1: 363.6,
    x2: 256.56,
    y2: 363.6,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 259.5,
    y1: 370.81,
    x2: 261.9,
    y2: 370.81,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 264.31,
    y1: 380.69,
    x2: 266.98,
    y2: 380.69,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 266.58,
    y1: 396.76,
    x2: 269.52,
    y2: 396.76,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 244.01,
    y1: 438.37,
    x2: 246.15,
    y2: 438.37,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 248.82,
    y1: 434.63,
    x2: 251.75,
    y2: 434.63,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 254.16,
    y1: 429.29,
    x2: 256.56,
    y2: 429.29,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 259.5,
    y1: 422.08,
    x2: 261.9,
    y2: 422.08,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 264.31,
    y1: 412.2,
    x2: 266.98,
    y2: 412.2,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 215.92,
    cy: 396.76,
    r: 50.67,
    transform: "translate(-219.41 517.28) rotate(-76.92)",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 215.92,
    cy: 396.76,
    r: 43.33,
    transform: "translate(-219.43 517.2) rotate(-76.91)",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.31,368.09v-4.17h7.21v4.17c6.26,1.29,9.47,6.1,9.47,13.72v1.76h-8.34v-2.32c0-4-1.61-5.54-4.41-5.54s-4.42,1.53-4.42,5.54c0,11.55,17.25,12.11,17.25,28.15,0,7.62-3.29,12.51-9.55,13.8v4.09h-7.21V423.2c-6.34-1.29-9.55-6.18-9.55-13.8v-3.85h8.34V410c0,4,1.77,5.46,4.57,5.46s4.58-1.45,4.58-5.46c0-11.55-17.25-12.11-17.25-28.15C203,374.27,206.13,369.46,212.31,368.09Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.17,368.09v-4.17h7.22v4.17c6.26,1.29,9.46,6.1,9.46,13.72v1.76h-8.34v-2.32c0-4-1.6-5.54-4.41-5.54s-4.41,1.53-4.41,5.54c0,11.55,17.24,12.11,17.24,28.15,0,7.62-3.28,12.51-9.54,13.8v4.09h-7.22V423.2c-6.34-1.29-9.54-6.18-9.54-13.8v-3.85H209V410c0,4,1.76,5.46,4.57,5.46s4.57-1.45,4.57-5.46c0-11.55-17.24-12.11-17.24-28.15C200.87,374.27,204,369.46,210.17,368.09Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 114.17,
    y: 304.51,
    width: 85.58,
    height: 7.61,
    transform: "translate(313.93 616.62) rotate(180)",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 195.23,
    y1: 304.68,
    x2: 195.23,
    y2: 311.79,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 197.71,
    y1: 304.68,
    x2: 197.71,
    y2: 311.79,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 190.29,
    y1: 304.68,
    x2: 190.29,
    y2: 311.79,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 185.34,
    y1: 304.68,
    x2: 185.34,
    y2: 311.79,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 180.4,
    y1: 304.68,
    x2: 180.4,
    y2: 311.79,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 175.45,
    y1: 304.68,
    x2: 175.45,
    y2: 311.79,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 168.04,
    y1: 304.68,
    x2: 168.04,
    y2: 311.79,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 155.67,
    y1: 304.68,
    x2: 155.67,
    y2: 311.79,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 114.17,
    y: 312.51,
    width: 85.58,
    height: 7.61,
    transform: "translate(313.93 632.62) rotate(180)",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 195.23,
    y1: 312.68,
    x2: 195.23,
    y2: 319.79,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 197.71,
    y1: 312.68,
    x2: 197.71,
    y2: 319.79,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 190.29,
    y1: 312.68,
    x2: 190.29,
    y2: 319.79,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 185.34,
    y1: 312.68,
    x2: 185.34,
    y2: 319.79,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 180.4,
    y1: 312.68,
    x2: 180.4,
    y2: 319.79,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 175.45,
    y1: 312.68,
    x2: 175.45,
    y2: 319.79,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 168.04,
    y1: 312.68,
    x2: 168.04,
    y2: 319.79,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 155.67,
    y1: 312.68,
    x2: 155.67,
    y2: 319.79,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 114.17,
    y: 296.62,
    width: 85.58,
    height: 7.61,
    transform: "translate(313.93 600.86) rotate(180)",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 195.23,
    y1: 296.8,
    x2: 195.23,
    y2: 303.9,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 197.71,
    y1: 296.8,
    x2: 197.71,
    y2: 303.9,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 190.29,
    y1: 296.8,
    x2: 190.29,
    y2: 303.9,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 185.34,
    y1: 296.8,
    x2: 185.34,
    y2: 303.9,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 180.4,
    y1: 296.8,
    x2: 180.4,
    y2: 303.9,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 175.45,
    y1: 296.8,
    x2: 175.45,
    y2: 303.9,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 168.04,
    y1: 296.8,
    x2: 168.04,
    y2: 303.9,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 155.67,
    y1: 296.8,
    x2: 155.67,
    y2: 303.9,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 114.17,
    y: 320.51,
    width: 85.58,
    height: 7.61,
    transform: "translate(313.93 648.62) rotate(180)",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 195.23,
    y1: 320.68,
    x2: 195.23,
    y2: 327.79,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 197.71,
    y1: 320.68,
    x2: 197.71,
    y2: 327.79,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 190.29,
    y1: 320.68,
    x2: 190.29,
    y2: 327.79,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 185.34,
    y1: 320.68,
    x2: 185.34,
    y2: 327.79,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 180.4,
    y1: 320.68,
    x2: 180.4,
    y2: 327.79,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 175.45,
    y1: 320.68,
    x2: 175.45,
    y2: 327.79,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 168.04,
    y1: 320.68,
    x2: 168.04,
    y2: 327.79,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 155.67,
    y1: 320.68,
    x2: 155.67,
    y2: 327.79,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 116.17,
    y: 328.51,
    width: 85.58,
    height: 7.61,
    transform: "translate(317.93 664.62) rotate(180)",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 197.23,
    y1: 328.68,
    x2: 197.23,
    y2: 335.79,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 199.71,
    y1: 328.68,
    x2: 199.71,
    y2: 335.79,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 192.29,
    y1: 328.68,
    x2: 192.29,
    y2: 335.79,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 187.34,
    y1: 328.68,
    x2: 187.34,
    y2: 335.79,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 182.4,
    y1: 328.68,
    x2: 182.4,
    y2: 335.79,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 177.45,
    y1: 328.68,
    x2: 177.45,
    y2: 335.79,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 170.04,
    y1: 328.68,
    x2: 170.04,
    y2: 335.79,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 157.67,
    y1: 328.68,
    x2: 157.67,
    y2: 335.79,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 114.17,
    y: 336.51,
    width: 85.58,
    height: 7.61,
    transform: "translate(313.93 680.62) rotate(180)",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 195.23,
    y1: 336.68,
    x2: 195.23,
    y2: 343.79,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 197.71,
    y1: 336.68,
    x2: 197.71,
    y2: 343.79,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 190.29,
    y1: 336.68,
    x2: 190.29,
    y2: 343.79,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 185.34,
    y1: 336.68,
    x2: 185.34,
    y2: 343.79,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 180.4,
    y1: 336.68,
    x2: 180.4,
    y2: 343.79,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 175.45,
    y1: 336.68,
    x2: 175.45,
    y2: 343.79,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 168.04,
    y1: 336.68,
    x2: 168.04,
    y2: 343.79,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 155.67,
    y1: 336.68,
    x2: 155.67,
    y2: 343.79,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 118.17,
    y: 344.51,
    width: 85.58,
    height: 7.61,
    transform: "translate(321.93 696.62) rotate(180)",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 199.23,
    y1: 344.68,
    x2: 199.23,
    y2: 351.79,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 201.71,
    y1: 344.68,
    x2: 201.71,
    y2: 351.79,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 194.29,
    y1: 344.68,
    x2: 194.29,
    y2: 351.79,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 189.34,
    y1: 344.68,
    x2: 189.34,
    y2: 351.79,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 184.4,
    y1: 344.68,
    x2: 184.4,
    y2: 351.79,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 179.45,
    y1: 344.68,
    x2: 179.45,
    y2: 351.79,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 172.04,
    y1: 344.68,
    x2: 172.04,
    y2: 351.79,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 159.67,
    y1: 344.68,
    x2: 159.67,
    y2: 351.79,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 119.67,
    y: 352.51,
    width: 85.58,
    height: 7.61,
    transform: "translate(324.93 712.62) rotate(180)",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 200.73,
    y1: 352.68,
    x2: 200.73,
    y2: 359.79,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 203.21,
    y1: 352.68,
    x2: 203.21,
    y2: 359.79,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 195.79,
    y1: 352.68,
    x2: 195.79,
    y2: 359.79,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 190.84,
    y1: 352.68,
    x2: 190.84,
    y2: 359.79,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 185.9,
    y1: 352.68,
    x2: 185.9,
    y2: 359.79,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 180.95,
    y1: 352.68,
    x2: 180.95,
    y2: 359.79,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 173.54,
    y1: 352.68,
    x2: 173.54,
    y2: 359.79,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 161.17,
    y1: 352.68,
    x2: 161.17,
    y2: 359.79,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 115.67,
    y: 360.51,
    width: 85.58,
    height: 7.61,
    transform: "translate(316.93 728.62) rotate(180)",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 196.73,
    y1: 360.68,
    x2: 196.73,
    y2: 367.79,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 199.21,
    y1: 360.68,
    x2: 199.21,
    y2: 367.79,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 191.79,
    y1: 360.68,
    x2: 191.79,
    y2: 367.79,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 186.84,
    y1: 360.68,
    x2: 186.84,
    y2: 367.79,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 181.9,
    y1: 360.68,
    x2: 181.9,
    y2: 367.79,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 176.95,
    y1: 360.68,
    x2: 176.95,
    y2: 367.79,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 169.54,
    y1: 360.68,
    x2: 169.54,
    y2: 367.79,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 157.17,
    y1: 360.68,
    x2: 157.17,
    y2: 367.79,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 117.88,
    y: 368.51,
    width: 85.58,
    height: 7.61,
    transform: "translate(321.35 744.62) rotate(180)",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 198.94,
    y1: 368.68,
    x2: 198.94,
    y2: 375.79,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 201.42,
    y1: 368.68,
    x2: 201.42,
    y2: 375.79,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 194,
    y1: 368.68,
    x2: 194,
    y2: 375.79,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 189.05,
    y1: 368.68,
    x2: 189.05,
    y2: 375.79,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 184.11,
    y1: 368.68,
    x2: 184.11,
    y2: 375.79,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 179.16,
    y1: 368.68,
    x2: 179.16,
    y2: 375.79,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 171.75,
    y1: 368.68,
    x2: 171.75,
    y2: 375.79,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 159.38,
    y1: 368.68,
    x2: 159.38,
    y2: 375.79,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 114.17,
    y: 376.51,
    width: 85.58,
    height: 7.61,
    transform: "translate(313.93 760.62) rotate(180)",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 195.23,
    y1: 376.68,
    x2: 195.23,
    y2: 383.79,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 197.71,
    y1: 376.68,
    x2: 197.71,
    y2: 383.79,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 190.29,
    y1: 376.68,
    x2: 190.29,
    y2: 383.79,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 185.34,
    y1: 376.68,
    x2: 185.34,
    y2: 383.79,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 180.4,
    y1: 376.68,
    x2: 180.4,
    y2: 383.79,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 175.45,
    y1: 376.68,
    x2: 175.45,
    y2: 383.79,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 168.04,
    y1: 376.68,
    x2: 168.04,
    y2: 383.79,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 155.67,
    y1: 376.68,
    x2: 155.67,
    y2: 383.79,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 114.17,
    y: 384.51,
    width: 85.58,
    height: 7.61,
    transform: "translate(313.93 776.62) rotate(180)",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 195.23,
    y1: 384.68,
    x2: 195.23,
    y2: 391.79,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 197.71,
    y1: 384.68,
    x2: 197.71,
    y2: 391.79,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 190.29,
    y1: 384.68,
    x2: 190.29,
    y2: 391.79,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 185.34,
    y1: 384.68,
    x2: 185.34,
    y2: 391.79,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 180.4,
    y1: 384.68,
    x2: 180.4,
    y2: 391.79,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 175.45,
    y1: 384.68,
    x2: 175.45,
    y2: 391.79,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 168.04,
    y1: 384.68,
    x2: 168.04,
    y2: 391.79,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 155.67,
    y1: 384.68,
    x2: 155.67,
    y2: 391.79,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 109.67,
    y: 392.51,
    width: 85.58,
    height: 7.61,
    transform: "translate(304.93 792.62) rotate(180)",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 190.73,
    y1: 392.68,
    x2: 190.73,
    y2: 399.79,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 193.21,
    y1: 392.68,
    x2: 193.21,
    y2: 399.79,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 185.79,
    y1: 392.68,
    x2: 185.79,
    y2: 399.79,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 180.84,
    y1: 392.68,
    x2: 180.84,
    y2: 399.79,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 175.9,
    y1: 392.68,
    x2: 175.9,
    y2: 399.79,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 170.95,
    y1: 392.68,
    x2: 170.95,
    y2: 399.79,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 163.54,
    y1: 392.68,
    x2: 163.54,
    y2: 399.79,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 151.17,
    y1: 392.68,
    x2: 151.17,
    y2: 399.79,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 111.67,
    y: 400.51,
    width: 85.58,
    height: 7.61,
    transform: "translate(308.93 808.62) rotate(180)",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 192.73,
    y1: 400.68,
    x2: 192.73,
    y2: 407.79,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 195.21,
    y1: 400.68,
    x2: 195.21,
    y2: 407.79,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 187.79,
    y1: 400.68,
    x2: 187.79,
    y2: 407.79,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 182.84,
    y1: 400.68,
    x2: 182.84,
    y2: 407.79,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 177.9,
    y1: 400.68,
    x2: 177.9,
    y2: 407.79,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 172.95,
    y1: 400.68,
    x2: 172.95,
    y2: 407.79,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 165.54,
    y1: 400.68,
    x2: 165.54,
    y2: 407.79,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 153.17,
    y1: 400.68,
    x2: 153.17,
    y2: 407.79,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 112.17,
    y: 408.51,
    width: 85.58,
    height: 7.61,
    transform: "translate(309.93 824.62) rotate(180)",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 193.23,
    y1: 408.68,
    x2: 193.23,
    y2: 415.79,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 195.71,
    y1: 408.68,
    x2: 195.71,
    y2: 415.79,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 188.29,
    y1: 408.68,
    x2: 188.29,
    y2: 415.79,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 183.34,
    y1: 408.68,
    x2: 183.34,
    y2: 415.79,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 178.4,
    y1: 408.68,
    x2: 178.4,
    y2: 415.79,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 173.45,
    y1: 408.68,
    x2: 173.45,
    y2: 415.79,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 166.04,
    y1: 408.68,
    x2: 166.04,
    y2: 415.79,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 153.67,
    y1: 408.68,
    x2: 153.67,
    y2: 415.79,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 114.17,
    y: 416.51,
    width: 85.58,
    height: 7.61,
    transform: "translate(313.93 840.62) rotate(180)",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 195.23,
    y1: 416.68,
    x2: 195.23,
    y2: 423.79,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 197.71,
    y1: 416.68,
    x2: 197.71,
    y2: 423.79,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 190.29,
    y1: 416.68,
    x2: 190.29,
    y2: 423.79,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 185.34,
    y1: 416.68,
    x2: 185.34,
    y2: 423.79,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 180.4,
    y1: 416.68,
    x2: 180.4,
    y2: 423.79,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 175.45,
    y1: 416.68,
    x2: 175.45,
    y2: 423.79,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 168.04,
    y1: 416.68,
    x2: 168.04,
    y2: 423.79,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 155.67,
    y1: 416.68,
    x2: 155.67,
    y2: 423.79,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 114.17,
    y: 424.51,
    width: 85.58,
    height: 7.61,
    transform: "translate(313.93 856.62) rotate(180)",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 195.23,
    y1: 424.68,
    x2: 195.23,
    y2: 431.79,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 197.71,
    y1: 424.68,
    x2: 197.71,
    y2: 431.79,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 190.29,
    y1: 424.68,
    x2: 190.29,
    y2: 431.79,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 185.34,
    y1: 424.68,
    x2: 185.34,
    y2: 431.79,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 180.4,
    y1: 424.68,
    x2: 180.4,
    y2: 431.79,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 175.45,
    y1: 424.68,
    x2: 175.45,
    y2: 431.79,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 168.04,
    y1: 424.68,
    x2: 168.04,
    y2: 431.79,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 155.67,
    y1: 424.68,
    x2: 155.67,
    y2: 431.79,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 112.17,
    y: 432.51,
    width: 85.58,
    height: 7.61,
    transform: "translate(309.93 872.62) rotate(180)",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 193.23,
    y1: 432.68,
    x2: 193.23,
    y2: 439.79,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 195.71,
    y1: 432.68,
    x2: 195.71,
    y2: 439.79,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 188.29,
    y1: 432.68,
    x2: 188.29,
    y2: 439.79,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 183.34,
    y1: 432.68,
    x2: 183.34,
    y2: 439.79,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 178.4,
    y1: 432.68,
    x2: 178.4,
    y2: 439.79,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 173.45,
    y1: 432.68,
    x2: 173.45,
    y2: 439.79,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 166.04,
    y1: 432.68,
    x2: 166.04,
    y2: 439.79,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 153.67,
    y1: 432.68,
    x2: 153.67,
    y2: 439.79,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 114.17,
    y: 440.51,
    width: 85.58,
    height: 7.61,
    transform: "translate(313.93 888.62) rotate(180)",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 195.23,
    y1: 440.68,
    x2: 195.23,
    y2: 447.79,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 197.71,
    y1: 440.68,
    x2: 197.71,
    y2: 447.79,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 190.29,
    y1: 440.68,
    x2: 190.29,
    y2: 447.79,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 185.34,
    y1: 440.68,
    x2: 185.34,
    y2: 447.79,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 180.4,
    y1: 440.68,
    x2: 180.4,
    y2: 447.79,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 175.45,
    y1: 440.68,
    x2: 175.45,
    y2: 447.79,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 168.04,
    y1: 440.68,
    x2: 168.04,
    y2: 447.79,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 155.67,
    y1: 440.68,
    x2: 155.67,
    y2: 447.79,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M599.41,415.67c-6.92-7.7-25.71-13.22-47.82-13.22-20.65,0-38.4,4.82-46.29,11.73l-4.38-.07v8.1c0,10.91,22.69,19.76,50.67,19.76s50.67-8.85,50.67-19.76v-6.49Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 551.59,
    cy: 415.72,
    rx: 50.67,
    ry: 19.76,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 551.59,
    cy: 415.72,
    rx: 43.33,
    ry: 16.9,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M548,404.54v-1.63h7.22v1.63c6.26.5,9.47,2.38,9.47,5.35v.69h-8.35v-.91c0-1.56-1.6-2.16-4.41-2.16s-4.41.6-4.41,2.16c0,4.51,17.25,4.73,17.25,11,0,3-3.29,4.88-9.55,5.38v1.6H548V426c-6.33-.5-9.54-2.41-9.54-5.38v-1.5h8.34v1.72c0,1.57,1.76,2.13,4.57,2.13s4.57-.56,4.57-2.13c0-4.5-17.24-4.72-17.24-11C538.68,407,541.81,405.07,548,404.54Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M548,403.37v-1.62h7.22v1.62c6.26.5,9.47,2.38,9.47,5.35v.69h-8.35v-.91c0-1.56-1.6-2.15-4.41-2.15s-4.41.59-4.41,2.15c0,4.51,17.25,4.73,17.25,11,0,3-3.29,4.88-9.55,5.38v1.59H548v-1.59c-6.33-.5-9.54-2.41-9.54-5.38V418h8.34v1.72c0,1.57,1.76,2.13,4.57,2.13s4.57-.56,4.57-2.13c0-4.5-17.24-4.72-17.24-11C538.68,405.78,541.81,403.91,548,403.37Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 504.17,
    y1: 429.18,
    x2: 504.17,
    y2: 423.37,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 508.1,
    y1: 431.85,
    x2: 508.1,
    y2: 426.51,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 512.34,
    y1: 434.36,
    x2: 512.34,
    y2: 428.55,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 518.15,
    y1: 436.87,
    x2: 518.15,
    y2: 430.59,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 525.06,
    y1: 435.56,
    x2: 525.06,
    y2: 432.79,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 525.06,
    y1: 438.92,
    x2: 525.06,
    y2: 437.82,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 534,
    y1: 440.8,
    x2: 534,
    y2: 434.68,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 545.94,
    y1: 437.5,
    x2: 545.94,
    y2: 435.3,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 545.94,
    y1: 441.74,
    x2: 545.94,
    y2: 440.01,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M651.62,428.89c-6.39-8.62-24.78-15.77-46.84-17.31-20.6-1.45-38.63,2.4-47,9.14l-4.37-.38-.53,8.55c-.72,11.53,21.33,22.45,49.25,24.41S653.31,447.51,654,436l.43-6.85Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 603.9,
    cy: 425.59,
    rx: 20.9,
    ry: 50.68,
    transform: "matrix(0.07, -1, 1, 0.07, 136.22, 997.51)",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 603.9,
    cy: 425.59,
    rx: 17.88,
    ry: 43.34,
    transform: "translate(136.22 997.51) rotate(-85.9)",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M601,413.53l.11-1.71,7.2.5-.11,1.72c6.21,1,9.29,3.17,9.09,6.31l0,.73-8.32-.59.06-1c.1-1.65-1.46-2.39-4.26-2.58s-4.45.32-4.55,2c-.3,4.75,16.9,6.19,16.48,12.8-.19,3.13-3.6,4.92-9.88,5l-.1,1.68-7.21-.5.11-1.69c-6.29-1-9.37-3.21-9.17-6.34l.1-1.59,8.32.58-.11,1.82c-.1,1.65,1.62,2.37,4.42,2.57s4.6-.28,4.7-1.93c.3-4.76-16.89-6.19-16.48-12.8C591.6,415.43,594.84,413.66,601,413.53Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M601.12,412.3l.11-1.72,7.2.51-.11,1.72c6.21,1,9.29,3.17,9.09,6.31l0,.72-8.33-.58.06-1c.11-1.65-1.45-2.39-4.26-2.59s-4.44.32-4.54,2c-.3,4.76,16.89,6.2,16.48,12.81-.2,3.13-3.6,4.92-9.88,5l-.11,1.68-7.2-.5.11-1.69c-6.29-1-9.37-3.21-9.17-6.35l.1-1.58,8.32.58-.11,1.82c-.11,1.65,1.62,2.37,4.42,2.56s4.6-.27,4.7-1.92c.3-4.76-16.89-6.2-16.48-12.8C591.67,414.19,594.92,412.43,601.12,412.3Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 555.7,
    y1: 436.48,
    x2: 556.08,
    y2: 430.35,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 559.44,
    y1: 439.57,
    x2: 559.79,
    y2: 433.94,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 563.5,
    y1: 442.52,
    x2: 563.89,
    y2: 436.39,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 569.13,
    y1: 445.58,
    x2: 569.55,
    y2: 438.95,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 576.11,
    y1: 444.68,
    x2: 576.3,
    y2: 441.76,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 575.89,
    y1: 448.22,
    x2: 575.96,
    y2: 447.06,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 584.7,
    y1: 450.84,
    x2: 585.1,
    y2: 444.37,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 596.82,
    y1: 448.19,
    x2: 596.97,
    y2: 445.87,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 596.54,
    y1: 452.67,
    x2: 596.65,
    y2: 450.84,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImg14);
export default __webpack_public_path__ + "static/media/img14.ef33e2f9c5edbc765e64a9dfb70ff334.svg";
export { ForwardRef as ReactComponent };